import React, { useContext, useMemo, useState } from "react";
import { LangContext } from "../../../context/lang/LangContext";
import { PhosphorIcon } from "../../PhosphorIcon/PhosphorIcon";
import { Icons } from "../../PhosphorIcon/types";
import Colors from "../../../utils/enums/colors";

enum ProductMenuItems {
  CostOptimization,
  Security,
  InfrastructureManagement,
}

export const useProductSubMenu = () => {
  const { messages } = useContext(LangContext);

  const [selectedSubMenu, setSelectedSubmenu] = useState(
    ProductMenuItems.CostOptimization,
  );

  const menuItems = useMemo(() => {
    return [
      {
        icon: (
          <PhosphorIcon
            icon={Icons.CloudArrowUpThin}
            size={24}
            color={
              selectedSubMenu === ProductMenuItems.CostOptimization
                ? Colors.Primary100
                : "white"
            }
          />
        ),
        title: messages.product.headerItems.costOptimizationInTheCloud,
        id: ProductMenuItems.CostOptimization,
        mobileIcon: (
          <PhosphorIcon
            icon={Icons.CloudArrowUpThin}
            size={24}
            color={"white"}
          />
        ),
      },
      {
        icon: (
          <PhosphorIcon
            icon={Icons.ShieldCheck}
            size={24}
            color={
              selectedSubMenu === ProductMenuItems.Security
                ? Colors.Primary100
                : "white"
            }
          />
        ),
        title: messages.product.headerItems.security,
        id: ProductMenuItems.Security,
        mobileIcon: (
          <PhosphorIcon icon={Icons.ShieldCheck} size={24} color={"white"} />
        ),
      },
      {
        icon: (
          <PhosphorIcon
            icon={Icons.CurrencyCircleDollar}
            size={24}
            color={
              selectedSubMenu === ProductMenuItems.InfrastructureManagement
                ? Colors.Primary100
                : "white"
            }
          />
        ),
        title: messages.product.headerItems.infrastructureManagement,
        id: ProductMenuItems.InfrastructureManagement,
        mobileIcon: (
          <PhosphorIcon
            icon={Icons.CurrencyCircleDollar}
            size={24}
            color={"white"}
          />
        ),
      },
    ];
  }, [selectedSubMenu, messages]);

  const menuSubItems = useMemo(() => {
    return [
      {
        title: messages.product.headerSubItems.costMonitoring,
        menuItemId: ProductMenuItems.CostOptimization,
        link: "cost-monitoring",
      },
      {
        title: messages.product.headerSubItems.monitoringAndTraceability,
        menuItemId: ProductMenuItems.CostOptimization,
        link: "monitoring-and-tracing",
      },
      {
        title: messages.product.headerSubItems.rolesAndPermissions,
        menuItemId: ProductMenuItems.Security,
        link: "roles-and-permissions",
      },
      {
        title: messages.product.headerSubItems.policyConfiguration,
        menuItemId: ProductMenuItems.Security,
        link: "policy-configuration",
      },
      {
        title: messages.product.headerSubItems.infrastructure,
        menuItemId: ProductMenuItems.Security,
        link: "infrastructure",
      },
      {
        title: messages.product.headerSubItems.vpnsSupport,
        menuItemId: ProductMenuItems.Security,
        link: "vpns-support",
      },
      {
        title:
          messages.product.headerSubItems
            .assistanceInArchitectureAndPerformanceImprovements,
        menuItemId: ProductMenuItems.Security,
        link: "assistance-in-architecture-and-performance-improvements",
      },
      {
        title: messages.product.headerSubItems.securitySupport,
        menuItemId: ProductMenuItems.Security,
        link: "security-support",
      },
      {
        title: messages.product.headerSubItems.autoscaling,
        menuItemId: ProductMenuItems.InfrastructureManagement,
        link: "autoscaling",
      },
      {
        title: messages.product.headerSubItems.logs,
        menuItemId: ProductMenuItems.InfrastructureManagement,
        link: "logs",
      },
      {
        title: messages.product.headerSubItems.reportingAndOptimization,
        menuItemId: ProductMenuItems.InfrastructureManagement,
        link: "reporting-and-optimization",
      },
      {
        title:
          messages.product.headerSubItems
            .implementationOfActionableMeasuresForCostOptimization,
        menuItemId: ProductMenuItems.InfrastructureManagement,
        link: "implementation-of-actionable",
      },
      {
        title: messages.product.headerSubItems.cicdDeployment,
        menuItemId: ProductMenuItems.InfrastructureManagement,
        link: "ci-cd",
      },
      {
        title: messages.product.headerSubItems.deploymentControl,
        menuItemId: ProductMenuItems.InfrastructureManagement,
        link: "deployment-control",
      },
      {
        title: messages.product.headerSubItems.supportedServices,
        menuItemId: ProductMenuItems.InfrastructureManagement,
        link: "supported-services",
      },
      {
        title: messages.product.headerSubItems.dataops,
        menuItemId: ProductMenuItems.InfrastructureManagement,
        link: "dataops",
      },
    ];
  }, []);
  return {
    menuItems,
    menuSubItems,
    selectedSubMenu,
    setSelectedSubmenu,
  };
};
